import Input from '#components/general/Input';
import { getSubStepValues } from '#models/general/steps';
import { mapPeriodsOptions } from '#models/periods';
import { getSelectField } from '#utils/select';

import { FEINTS_SUBSTEPS_IDS, FEINT_INITIAL_PAGE_FIELDS } from './constants';

export const getInitialPageFields = ({ values, errors, periods }) => {
  const getInitialPageValues = getSubStepValues(FEINTS_SUBSTEPS_IDS.INITIAL_PAGE, values, errors);
  return [
    getSelectField({
      field: FEINT_INITIAL_PAGE_FIELDS.PERIOD_ID,
      values,
      options: mapPeriodsOptions(periods),
      customOptions: true,
      getValues: getInitialPageValues
    }),
    {
      ...getInitialPageValues(FEINT_INITIAL_PAGE_FIELDS.DATE),
      Component: Input,
      type: 'date',
      noMargin: true
    },
    {
      ...getInitialPageValues(FEINT_INITIAL_PAGE_FIELDS.OPERATOR),
      Component: Input,
      noMargin: true
    }
  ];
};
